import {
  SidebarGroup,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/components/ui/sidebar';
import { AnimatePresence, motion } from 'framer-motion';
import { type LucideIcon } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

export type NavItem = {
  title: string;
  url: string;
  icon: LucideIcon;
  matchUrl?: string;
};

export interface NavMainProps {
  items: NavItem[];
}

export const NavMain = ({ items }: NavMainProps) => {
  const location = useLocation();

  return (
    <SidebarGroup>
      <SidebarMenu>
        <AnimatePresence mode="sync">
          {items.map((item) => {
            const isActive =
              item.url === '/'
                ? location.pathname === '/'
                : location.pathname.startsWith(item.matchUrl || item.url);
            const Icon = item.icon;

            return (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -20 }}
                transition={{ duration: 0.3 }}>
                <SidebarMenuItem>
                  <SidebarMenuButton
                    asChild
                    tooltip={item.title}
                    isActive={isActive}>
                    <Link to={item.url}>
                      <Icon className="h-4 w-4" />
                      <p>{item.title}</p>
                    </Link>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              </motion.div>
            );
          })}
        </AnimatePresence>
      </SidebarMenu>
    </SidebarGroup>
  );
};
